import { render } from "./RepeatedErrorsPanel.vue?vue&type=template&id=1490ba32&scoped=true"
import script from "./RepeatedErrorsPanel.vue?vue&type=script&lang=js"
export * from "./RepeatedErrorsPanel.vue?vue&type=script&lang=js"

import "./RepeatedErrorsPanel.vue?vue&type=style&index=0&id=1490ba32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1490ba32"]])

export default __exports__